import React from 'react'
import SignIn from '../components/SignIn/Index';

const SignInPage = () => {
    return (
        <div>
           <SignIn/>
        </div>
    )
}

export default SignInPage;